import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import {
  DataRow,
  DataValue,
  HeaderContainer,
  ResultContainer,
  HeaderCell,
  BodyCell,
  HeaderText,
  NoDataView
} from './student-result-table.styled';
import SvgIcon from '../../../../svg-icon/svg-icon';

const StudentResultTable = ({ i18n, data, quality, icon }) => {
  let displayQualities;
  let noDataMessage;
  let headerCell;

  if (quality === 'Strength') {
    displayQualities = data.topActivities;

    noDataMessage = i18n._(
      t(
        'studentResultTable.weaknessNoDataMessage'
      )`The activities the student excelled at most will be shown here.`
    );

    headerCell = (
      <DataRow>
        <HeaderContainer key={data.activityId} icon={icon}>
          <HeaderText data-testid="strength-header">
            {i18n._(t('studentResultTable.strength')`Excelling most at`)}
          </HeaderText>
          <SvgIcon icon={icon} />
        </HeaderContainer>
      </DataRow>
    );
  } else {
    displayQualities = data.bottomActivities;

    noDataMessage = i18n._(
      t(
        'studentResultTable.strengthsNoDataMessage'
      )`The activities the student struggled most with will be displayed here.`
    );

    headerCell = (
      <DataRow>
        <HeaderContainer key={data.activityId}>
          <HeaderText data-testid="weakness-header">
            {i18n._(t('studentResultTable.weakness')`Needs most help with`)}
          </HeaderText>
          <SvgIcon icon={icon} />
        </HeaderContainer>
      </DataRow>
    );
  }

  const bodyCell =
    displayQualities && displayQualities.length > 0 ? (
      displayQualities.map((item) => (
        <DataRow key={item.activityId} data-testid="activitiesTable">
          <DataValue title={item.activityName}>{item.activityName}</DataValue>
          <DataValue title={item.topicName}>{item.topicName}</DataValue>
        </DataRow>
      ))
    ) : (
      <NoDataView data-testid="noDataView">
        <div>{noDataMessage}</div>
      </NoDataView>
    );

  return (
    <ResultContainer>
      <HeaderCell>{headerCell}</HeaderCell>
      <BodyCell>{bodyCell}</BodyCell>
    </ResultContainer>
  );
};

StudentResultTable.propTypes = {
  i18n: PropTypes.object,
  data: PropTypes.object,
  icon: PropTypes.string,
  quality: PropTypes.string
};

export default StudentResultTable;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-result/student-result-table/student-result-table.js